import Box from "@mui/material/Box";
import { observer } from "mobx-react";
import { useEffect } from "react";
import ProjectAnalysisTabBar from "../ProjectAnalysisTabBar/ProjectAnalysisTabBar";

const ProjectAnalysisPage = observer(() => {
  console.log("ProjectAnalysisPage render");

  useEffect(() => {
    return () => {
      console.log("ProjectAnalysisPage unmount");
    };
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        fontWeight: "bold",
        /*marginTop: "42px",*/
        textAlign: "left",
      }}
    >
      <ProjectAnalysisTabBar />
    </Box>
  );
});

export default ProjectAnalysisPage;
